const Blank = () => {
  return (
    <div>
      <div class="container-fluid">
        <h1 class="h3 mb-4 text-gray-800">Blank Page</h1>
      </div>
    </div>
  );
}

export default Blank;